import React, { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useToast } from '../context/ToastContext';
import api from "../services/api";
import { useAuth } from '../providers/auth';
import Loading from '../components/Loading';
import { SCButton, SCInputText } from '../components';
import { Divider } from 'primereact/divider';

interface Props {
    alunoId?: any;
    setShowDialogAltNome(param: boolean): void;
    reload(): void;
    loading: boolean;
    setLoading(param: boolean): void;
    aluno?: any;
}

const AlunosFormAlteraNome: React.FC<Props> = ({ alunoId = undefined, reload, setLoading, loading, aluno, setShowDialogAltNome }) => {
    // é utilizado para o cadastro da ajuda da tela (todas as telas devem ter essa informação)
    // por padrão vamos utilizar o mesmo nome do componente
    const tarefa = 'AlunosFormAlteraNome';
    const toast = useToast();
    const { periodoSelecionado } = useAuth();

    const { control, formState: { errors }, getValues, setValue, reset, watch } = useFormContext();

    const watchMatricula = watch('Matricula')
    const watchNome = watch('Nome')

    async function load(id: any) {
        setLoading(true)
        const { data } = await api.get('/aluno', {
            params: { AlunoId: id }
        })

        const alunoperiodo = await api.get('/alunosPeriodo/matricula', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
                Matricula: data.Matricula
            }
        });

        data.Turma = {
            Codigo: alunoperiodo.data.TurmaCodigo,
        };

        data.AlunosPeriodo = alunoperiodo.data;
        data.DataNascimento = data.DataNascimento ? new Date(data.DataNascimento) : new Date();
        data.DataDeferimento = data.DataDeferimento ? new Date(data.DataDeferimento) : new Date();

        reset(data);

        setLoading(false)
    }

    useEffect(() => {
        if (alunoId !== undefined)
            load(alunoId)

    }, [alunoId])

    const watchTurma = watch('Turma');
    useEffect(() => {
        if (watchTurma) {
            if (watchTurma?.NaoAplicaEF)
                setValue('AlunosPeriodo.TurmaEF', '');
            else
                setValue('AlunosPeriodo.TurmaEF', watchTurma?.CodigoTurmaEF);

        }
    }, [watchTurma])

    const alterarNome = async () => {
        try {
            if (watchNome === '') {
                toast.showToast({ severity: 'error', summary: 'Erro!', detail: 'Nome do Aluno não pode ser vazio.' });
                return;
            }

            setLoading(true)
            const dadosUpdate = {
                Nome: watchNome,
                Matricula: watchMatricula
            }
            await api.put('/aluno/updateNomeAlunoDiarioFinanceiro', dadosUpdate)
            toast.showToast({ severity: 'success', summary: 'Sucesso', detail: 'Nome alterado com sucesso.' });
            setShowDialogAltNome(false);
            reload()
        } catch {
            toast.showToast({ severity: 'error', summary: 'Erro!', detail: 'Erro ao atualizar Nome do Aluno.' });
            return;
        } finally {
            setLoading(false)
        }
    }

    const cancelar = () => {
        setShowDialogAltNome(false);
    };

    return (
        <>
            {loading && <Loading full={true} />}
            <div className="col-12">
                <div className='grid'>
                    <div className="col-2">
                        <SCInputText
                            style={{ textTransform: 'uppercase', border: 'none', color: '#0f97c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                            name='Matricula'
                            value={aluno.Matricula}
                            label='Matrícula'
                            disabled
                        />
                    </div>

                    <div className="col-10">
                        <SCInputText
                            autoFocus
                            autoComplete='no'
                            style={{ textTransform: 'uppercase', color: '#0f97c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                            name='Nome'
                            control={control}
                            errors={errors}
                            label='Novo Nome'
                        />
                    </div>
                </div>
            </div>

            <Divider />
            <div className="flex flex-1 justify-content-between">
                <SCButton label="Cancelar" icon="pi pi-times" className="p-button w-auto p-button-danger p-button-outlined" type='button' onClick={cancelar} />
                <SCButton onClick={alterarNome} label="Gravar" icon="pi pi-check" className="p-button w-auto p-button-success" />
            </div>
        </>
    );
};

export default AlunosFormAlteraNome;
